import type { CreateRepresentativeInput, UpdateRepresentativeInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import {
  createRepresentative,
  deleteRepresentative,
  updateRepresentative
} from '../services/representatives-admin.service'

export const useCreateRepresentativeMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateRepresentativeInput) => await createRepresentative(payload),
    onSuccess: () => {
      toast.success('Representante creado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.representatives.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateRepresentativeMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateRepresentativeInput }) =>
      await updateRepresentative(id, payload),
    onSuccess: () => {
      toast.success('Representante actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.representatives.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteRepresentativeMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteRepresentative(id),
    onSuccess: () => {
      toast.success('Representante eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.representatives.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
